"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authMachine = void 0;
var analytics_1 = require("@centered/analytics");
var firebase_1 = require("@centered/firebase");
var helpers_1 = require("@centered/helpers");
var xstate_1 = require("xstate");
var getCookie_1 = require("./getCookie");
exports.authMachine = 
/** @xstate-layout N4IgpgJg5mDOIC5QEECuAXAFgOgDIHsoBLAO2wEkIAbMAYgKgAJySBtABgF1FQAHfWEXRF8JHiAAeiAIzsAHACZsAFlnSArAHZ17ZQoWa5AGhABPRAFplc6dgWL1GnQGYAnADYF7gL7eTaLDxCUmxkdHQwAFteYRImBlJ6YJJGAGVUAGMMsEhIDm4kEH5BYVFxKQRpZVclTWV1Z3V3V1dtdWsTcwQrLWxNV2VnaWd3d0N+5R8-EACcBLIwiOjY+OTaAFVYMAAnRgA5fHRGADF8VBIIfPFioRExQoqqr2x2TSG5dXUW5U1paU7LI12CoFJNWjp2BpNApfP4MHNkqFwlEYqRVsQSLQAKLbbb4bZXQo3Ur3UCPdg1F51OqydjNbSaAHdZzVbByEb9N6tVzqRRTOGBVJEKAkVC8CjUOhCkWMda8Ql8AS3MoPRAKaStbDuDQtByvBTqJkWdrObDOTTapoWlnuVSwmbw7DS0XixYolZpYUu2jOsVpTLZXKXLjXJUk8pq+rAi3SfqvXnOZzsZxG5TsJTSOTJ1zOOTauTffkOwVesVIpaouKekVi7G4-EKophu4RhD6V7YAbNLxZsGfVMGrXuPPNVyKWQue2zbAAJTgYCOAAUAIawWAAd3xEAlNFoc62S9XG63jeJLdVbfa7iH5pGscm1SNbz6nhj6eqaZaU8d+4XjBXa6bts26-uEaJ7mAACOqBwEcoH-keQEQP6WQ5BAeQhkSzYqmSap1MoQ7SJ4SYTk0TJ-ARvyyDm7iJlmmjpt+gTwQBx7AbO85gXEdZ4gSmGKiU564W21imk07g6LRyYaCmZiID8bKGImOitMMqlMTgi5EBkADWCGAVuO50Fpun6WxwYFAJyqkpIiCJp4dgstYtoMf8cmVAYfQjMoaZeK8WYfBp2AmXprFIRxB4emFW4QQeZlIShgboRZoaCThtkIHepo-AM6YSf0VRMqCSjqO2DH6NChjqEFIXxYZoFRYhMU4rxp7YTZFQsuw6hsroqkeF8BbKEVEkvKCRHdeJ7DvjV2mhU17G1dFwGMAAwqIABmRDbJEy4krQEiwOge1gNgy4bRE2wABQKNN7AAJS0NOS0LduL0GSt60kFtO17XcbVpR1MjuHSIKDI0ii3a0TKNGa9Q6P07TUhJQVfSQYAZEcAAq+CMAAInAOnoPgvCMMgvDipQu5oxjRwE7ARMkwD1mtkmuZsrGpUKG4yb1EatE9Qa1TaDmWg8q4qOiOjmOMDja2YHikRgIwWISBEJCCKIRm0DTMuq+rmtsPxTaA6zvw9YYrTOPoIOfAoRoND1Y56FCaYQzC0yzLQADiuPE4w8zM+GF60q4KiaNoFLDD8uaGu5Fh5po2AatC7KZho94aT7fu4768rG2e6UVPoBZ2HIVXDNzVRuV0CdjMnrQGJN0jqp4We+4w-ssa9QdCRlBjW52LTJu0dKqD5qbNH0maldNOUeNI7c5-+c11cBvdF3ZBqmnUY4TnU9g5qmbgqD5rQFrSvxyEvne47rdOE8T+eWSbLMXgoLQW8m8gMeXYzDfHAYBFPiZlUCDawmYPYCkwNnW+a0pa03lorZW+swAa3+gXdqrNmjXjcK4dMqcPgeHtvHAswJhyfC+CRaEQwb7+2QFkM4JAjj3wwi-QuQNMp6FNPIGwfkahuANEaOQCleSeA-sOeQV46F3wVvgJWKs1ZoMNrKEgpAjrLioFQDenDK61CGDg5S7JXDCJaGabqPx8zWDHB7aYJB8DoXgIUacVMwCpTfsJIhWp2Q+SIp8OiADa74IIhJSY8gaiqQ0EFeYRl3HB2EgMJO5VqhJmmmQmulhuGdmqOXHUPwm7OGiYiN0yw0QB2SHEvujwP7kMhKVcuXwmjmlTDYPoAwDFyBERaN4ygikYiCBieB0QaAREqZvSoDEk7WIGDmCOOpZK13qHIOw7SPDQhsZ8PppAxmcILGHZJOY7rpIdgxNpqgaivEmXUIKedYlYVNu-OkYdRjpg+OAr4jJ46OFNH8GZezxpERuaWV0yJSlVjzjs1sALp4NB8qJHktoHbmmThqRwLRcyZl+ECms4o85DN4CMtx9yPH93HlSMYSYxwckCYCCkLwREGGHLaeM1VPaOghcS+J-d0y2BefYJougPn80HuaEGQweRaBpEFbuH1tyuMhe-WOWoKRpk5LaA0JDFkERGEmAwE1ppOWlZxNeIFOIrAVcJAweZk7jU+DmGZox+bLJGPyho5obCjFZdAiKf5lqmrin6+B31tq7S5RwqF2hbB-DzI0dF+UirTReLoK11tEyTGuWy5ixq-UWv7omJOINcpqr0KVI0RFaieFop4WMBoKQS0zZpVefq7lWS5Z1A0yyvivD+LyfQTQ45dFugRMcDQ6iwszOXXpDbgpNtej6riTAc2cqqXZJoYcfgOCciIkY7hyKeX0JMK0VKswt1mqZZt71zJBp+qGvu4aLyNEcCoFOTdOkGE+V0UVNrdTdQoW8TQZ75qytze22Q2Au1UV7QaCSMNlkHsMBNEGrkvXFhwPfWWuN6aM1JuTSmkoQNqjHMCWFBgGi1u5jS7ow5TQSVjBMHyUdJYkGltjTDj8SZkwpgRtsOYSoslI9bHQFGnzQi1GirwGgGnWyYyxjDSD5EoKUegrW8rl3jJ1U7dsXVXjpmaV80qKhSoRw+PUp5MnEFy1WnIhRqDlM2XvcJCGScai3W0+VPTtdbS2HqB-DV-9miL2nQwjITCWEIMxpAbj-HO2qApBJcukMP2WDHXDaakDv49tRtZxTBs7iqPUcdLR3HK4EXZNbZo1geWauS8ONkaY0v2A-onDS3GbC8p8WA-xuZKMWFkImcDjgREjkmdUXwvggA */
(0, xstate_1.createMachine)({
    tsTypes: {},
    schema: {
        context: {},
        events: {},
    },
    id: "Auth",
    initial: "Idle",
    on: {
        "*": {
            actions: "logState",
        },
        "Go to Login": {
            target: ".Login",
        },
        "Go to Signup": {
            target: ".Signup",
        },
        "Go to Reset Password": {
            target: ".Reset Password",
            actions: "clearError",
        },
        "Go to Pick Password": {
            target: ".Pick Password",
        },
        "Go to Connect Desktop": {
            target: ".Connect To Desktop App",
        },
        "Go to Connect Chrome Extension": {
            target: ".Connect To Chrome Extension",
            actions: "setExtensionId",
        },
        "Go to Account Connected": {
            target: ".Account Connected",
        },
        "Go to Chrome Extension Uninstall": {
            target: ".Chrome Extension Uninstall",
            actions: "setExtensionUninstallUserId",
        },
    },
    states: {
        Idle: {},
        Login: {
            initial: "Idle",
            states: {
                Idle: {
                    on: {
                        "Log In": {
                            target: "Attempting Login",
                            actions: "setCredentials",
                        },
                    },
                },
                "Attempting Login": {
                    invoke: {
                        src: "login",
                    },
                    on: {
                        "Login Succeeded": {
                            target: "Login Complete",
                        },
                        "User Not Found": {
                            target: "#Auth.Signup",
                        },
                        Error: {
                            target: "Idle",
                            actions: "setError",
                        },
                    },
                },
                "Login Complete": {
                    type: "final",
                },
            },
        },
        Signup: {
            initial: "Idle",
            states: {
                Idle: {
                    on: {
                        "Sign Up": {
                            target: "Attempting Signup",
                            actions: "setCredentials",
                        },
                    },
                },
                "Attempting Signup": {
                    invoke: {
                        src: "signup",
                    },
                    on: {
                        "Signup Succeeded": {
                            target: "Signup Complete",
                        },
                        Error: {
                            target: "Idle",
                            actions: "setError",
                        },
                    },
                },
                "Signup Complete": {
                    type: "final",
                },
            },
        },
        "Reset Password": {
            initial: "Idle",
            states: {
                Idle: {
                    on: {
                        "Reset Password": {
                            target: "Resetting",
                            actions: "setCredentials",
                        },
                    },
                },
                Resetting: {
                    invoke: {
                        src: "requestResetPassword",
                    },
                    on: {
                        "Request Reset Password Succeeded": {
                            target: "Reset Password Confirmation",
                        },
                        Error: {
                            target: "Idle",
                            actions: "setError",
                        },
                    },
                },
                "Reset Password Confirmation": {
                    type: "final",
                },
            },
        },
        "Pick Password": {
            initial: "Idle",
            states: {
                Idle: {
                    on: {
                        "Pick Password": {
                            target: "Resetting Password",
                            actions: "setCredentials",
                        },
                    },
                },
                "Resetting Password": {
                    invoke: {
                        src: "resetPassword",
                    },
                    on: {
                        "Reset Password Succeeded": {
                            target: "Pick Password Confirmation",
                        },
                        Error: {
                            target: "Idle",
                            actions: "setError",
                        },
                    },
                },
                "Pick Password Confirmation": {
                    after: {
                        "2000": {
                            target: "#Auth.Login",
                            actions: [],
                            internal: false,
                        },
                    },
                },
            },
        },
        "Connect To Desktop App": {
            initial: "Idle",
            states: {
                Idle: {
                    on: {
                        "Connect Desktop": {
                            target: "Idle",
                            actions: "connectToDesktop",
                            internal: false,
                        },
                    },
                },
            },
        },
        "Connect To Chrome Extension": {
            initial: "Idle",
            states: {
                Idle: {
                    on: {
                        "Connect Extension": {
                            target: "Idle",
                            actions: ["setExtensionId", "connectToChromeExtension"],
                            internal: false,
                        },
                    },
                },
            },
        },
        "Account Connected": {
            type: "final",
        },
        "Chrome Extension Uninstall": {
            invoke: {
                src: "uninstallChromeExtension",
            },
        },
    },
}, {
    actions: {
        logState: function (_context, event) {
            console.debug("[authMachine]:logState", event);
        },
        clearError: (0, xstate_1.assign)({
            error: function (_context) { return ""; },
        }),
        connectToDesktop: function () { return __awaiter(void 0, void 0, void 0, function () {
            var token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, firebase_1.firestorePOSTAsCurrentUser)("createCustomAuthToken", {})];
                    case 1:
                        token = _a.sent();
                        window.location.href = "centered://login/".concat(token.result.customToken);
                        return [2 /*return*/];
                }
            });
        }); },
        connectToChromeExtension: function (_a) {
            var chromeExtensionId = _a.chromeExtensionId;
            return __awaiter(void 0, void 0, void 0, function () {
                var token;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, (0, firebase_1.firestorePOSTAsCurrentUser)("createCustomAuthToken", {})
                            // @ts-expect-error – chrome is only available on Chrome 🙄
                        ];
                        case 1:
                            token = _b.sent();
                            // @ts-expect-error – chrome is only available on Chrome 🙄
                            chrome.runtime.sendMessage(chromeExtensionId, {
                                customToken: token.result.customToken,
                            });
                            return [2 /*return*/];
                    }
                });
            });
        },
        setExtensionId: (0, xstate_1.assign)({
            chromeExtensionId: function (_context, event) {
                return event.chromeExtensionId;
            },
        }),
        setExtensionUninstallUserId: (0, xstate_1.assign)({
            chromeExtensionUninstallUserId: function (_context, event) {
                return event.chromeExtensionUninstallUserId;
            },
        }),
        setCredentials: (0, xstate_1.assign)({
            email: function (context, event) {
                return event.type === "Log In" ||
                    event.type === "Sign Up" ||
                    event.type === "Reset Password"
                    ? event.email
                    : context.email;
            },
            password: function (context, event) {
                return event.type === "Log In" ||
                    event.type === "Sign Up" ||
                    event.type === "Pick Password"
                    ? event.password
                    : context.password;
            },
            name: function (context, event) {
                return event.type === "Sign Up" ? event.name : context.password;
            },
            error: function (_context) { return undefined; },
        }),
        setError: (0, xstate_1.assign)({ error: function (_context, event) { return event.error; } }),
    },
    services: {
        login: function (_a) {
            var email = _a.email, password = _a.password;
            return function (send) {
                var login = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var credential;
                    var _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                if (!email) {
                                    send({ type: "Error", error: "Please enter your email." });
                                    return [2 /*return*/];
                                }
                                if (!password) {
                                    send({ type: "Error", error: "Please enter your password." });
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, firebase_1.auth.signInWithEmailAndPassword(email, password)];
                            case 1:
                                credential = _c.sent();
                                if ((_a = credential.user) === null || _a === void 0 ? void 0 : _a.uid) {
                                    (0, analytics_1.trackEvent)("Login", {
                                        id: credential.user.uid,
                                        name: (_b = credential.user.displayName) !== null && _b !== void 0 ? _b : "Unknown",
                                        email: email,
                                        authMethod: "password",
                                        isMobile: (0, helpers_1.checkIsMobile)(),
                                    });
                                }
                                (0, analytics_1.trackEvent)("Continue with auth", {
                                    to: "app",
                                });
                                send("Login Succeeded");
                                return [2 /*return*/];
                        }
                    });
                }); };
                login().catch(function (error) {
                    if (error.code === "auth/user-not-found") {
                        (0, analytics_1.trackEvent)("Continue with auth", {
                            to: "sign up",
                        });
                        send("User Not Found");
                    }
                    else {
                        send({ type: "Error", error: error.message });
                    }
                });
            };
        },
        requestResetPassword: function (_a) {
            var email = _a.email;
            return function (send) {
                if (!email) {
                    send({ type: "Error", error: "Please enter your email." });
                    return;
                }
                firebase_1.auth
                    .sendPasswordResetEmail(email)
                    .then(function () { return send("Request Reset Password Succeeded"); })
                    .catch(function (error) { return send({ type: "Error", error: error.message }); });
            };
        },
        resetPassword: function (_a) {
            var password = _a.password, resetPasswordToken = _a.resetPasswordToken;
            return function (send) {
                if (!password) {
                    send({ type: "Error", error: "Please enter your password." });
                    return;
                }
                if (!resetPasswordToken) {
                    send({
                        type: "Error",
                        error: "There is no password reset token.",
                    });
                    return;
                }
                firebase_1.auth
                    .confirmPasswordReset(resetPasswordToken, password)
                    .then(function () { return send("Reset Password Succeeded"); })
                    .catch(function (error) { return send({ type: "Error", error: error.message }); });
            };
        },
        signup: function (_a) {
            var email = _a.email, password = _a.password, name = _a.name;
            return function (send) {
                var signup = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var isSignup, e_1, invitedByUserId, locallyStoredInvitedByUserId, invitedIntoGroupId, locallyStoredInvitedIntoGroupId, fbp, fbc, ttclid, gclaw, gclid;
                    var _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                if (!email) {
                                    send({ type: "Error", error: "Please enter your email." });
                                    return [2 /*return*/];
                                }
                                if (!password) {
                                    send({ type: "Error", error: "Please enter a password." });
                                    return [2 /*return*/];
                                }
                                if (!name) {
                                    send({ type: "Error", error: "Please enter your name." });
                                    return [2 /*return*/];
                                }
                                if (name.toLowerCase() === "anonymous") {
                                    send({
                                        type: "Error",
                                        error: "Our friendly community uses real names - please choose a valid name to join.",
                                    });
                                    return [2 /*return*/];
                                }
                                isSignup = true;
                                _c.label = 1;
                            case 1:
                                _c.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, firebase_1.auth.createUserWithEmailAndPassword(email, password)];
                            case 2:
                                _c.sent();
                                return [3 /*break*/, 4];
                            case 3:
                                e_1 = _c.sent();
                                send({ type: "Error", error: e_1.message });
                                return [2 /*return*/];
                            case 4:
                                invitedByUserId = undefined;
                                if (window && window.sessionStorage) {
                                    try {
                                        locallyStoredInvitedByUserId = sessionStorage.getItem("invitedByUserId");
                                        if (locallyStoredInvitedByUserId) {
                                            invitedByUserId = JSON.parse(locallyStoredInvitedByUserId);
                                        }
                                    }
                                    catch (e) {
                                        console.log("Error parsing invitedByUserId from sessionStorage", e);
                                    }
                                }
                                invitedIntoGroupId = undefined;
                                if (window && window.sessionStorage) {
                                    try {
                                        locallyStoredInvitedIntoGroupId = sessionStorage.getItem("invitedIntoGroupId");
                                        if (locallyStoredInvitedIntoGroupId) {
                                            invitedIntoGroupId = JSON.parse(locallyStoredInvitedIntoGroupId);
                                        }
                                    }
                                    catch (e) {
                                        console.log("Error parsing invitedIntoGroupId from sessionStorage", e);
                                    }
                                }
                                fbp = (0, getCookie_1.getCookie)("_fbp");
                                fbc = (0, getCookie_1.getCookie)("_fbc");
                                ttclid = (0, getCookie_1.getCookie)("ttclid");
                                gclaw = (_a = (0, getCookie_1.getCookie)("_gcl_aw")) === null || _a === void 0 ? void 0 : _a.split(".");
                                gclid = gclaw ? gclaw[gclaw.length - 1] : undefined;
                                if (!(name && email && password)) return [3 /*break*/, 6];
                                console.debug("[authMachine:signup] calling createUser");
                                return [4 /*yield*/, (0, firebase_1.createUser)(name, {
                                        invitedByUserId: invitedByUserId,
                                        invitedIntoGroupId: invitedIntoGroupId,
                                        conversionTracking: fbc || fbp || gclid || ttclid
                                            ? {
                                                fbc: fbc,
                                                fbp: fbp,
                                                gclid: gclid,
                                                ttclid: ttclid,
                                            }
                                            : undefined,
                                    })];
                            case 5:
                                _c.sent();
                                if ((_b = firebase_1.auth.currentUser) === null || _b === void 0 ? void 0 : _b.uid) {
                                    (0, analytics_1.identify)(firebase_1.auth.currentUser.uid, {
                                        id: firebase_1.auth.currentUser.uid,
                                        name: name,
                                        email: email,
                                    });
                                    (0, analytics_1.trackEvent)(isSignup ? "SignUp" : "Login", {
                                        id: firebase_1.auth.currentUser.uid,
                                        name: name,
                                        email: email,
                                        authMethod: "password",
                                        referredBy: invitedByUserId,
                                        fbp: fbp,
                                        fbc: fbc,
                                        gclid: gclid,
                                        ttclid: ttclid,
                                        isMobile: (0, helpers_1.checkIsMobile)(),
                                    });
                                }
                                // // Call Tolt signup function if referral exists
                                if (window.tolt_referral) {
                                    window.tolt.signup(email);
                                }
                                // TODO: call this from the refactored signup flow
                                send("Signup Succeeded");
                                _c.label = 6;
                            case 6: return [2 /*return*/];
                        }
                    });
                }); };
                signup().catch(function (error) { return send({ type: "Error", error: error }); });
            };
        },
        uninstallChromeExtension: function (_a) {
            var chromeExtensionUninstallUserId = _a.chromeExtensionUninstallUserId;
            return function (send) {
                var _a;
                if (!chromeExtensionUninstallUserId)
                    return;
                if (((_a = firebase_1.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== chromeExtensionUninstallUserId)
                    return;
                firebase_1.firebase
                    .database()
                    .ref("users/".concat(chromeExtensionUninstallUserId, "/activeTab"))
                    .remove()
                    .then(function () { return send("Extension Uninstall Succeeded"); });
            };
        },
    },
});
